export default __webpack_public_path__ + "3ef1de46eb253ce355080ca3ee5dd99b.svg";